import {gql, useQuery} from '@apollo/client';
import {pickLocalizedText} from '../../../../../utils/i18nText';

/** 审核驳回理由字典项（与 Kotlin ReviewRejectReasonOptionType 对齐：code + 可扩展多语言文案 texts） */
export interface ReviewRejectReasonOption {
    code: string;
    displayOrder?: number;
    texts: {lang: string; text: string}[];
}

export const GET_REVIEW_REJECT_REASON_LIST = gql`
    query GetReviewRejectReasonList {
        getReviewRejectReasonList {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
    }
`;

interface GetReviewRejectReasonListResponse {
    getReviewRejectReasonList: ReviewRejectReasonOption[];
}

/** 审核驳回理由字典（cache-and-network：挂载时回源刷新，与后端白名单一致；仅含当前可选项，历史停用 code 不下发）。
 *  按 displayOrder 升序由后端保证；前端不再硬编码 i18n key 列表 */
export const useReviewRejectReasons = () => {
    const {data, loading} = useQuery<GetReviewRejectReasonListResponse>(GET_REVIEW_REJECT_REASON_LIST, {
        fetchPolicy: 'cache-and-network',
    });
    return {
        options: data?.getReviewRejectReasonList ?? [],
        loading,
    };
};

export const GET_REVIEW_APPROVE_REASON_LIST = gql`
    query GetReviewApproveReasonList {
        getReviewApproveReasonList {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
    }
`;

interface GetReviewApproveReasonListResponse {
    getReviewApproveReasonList: ReviewRejectReasonOption[];
}

/** 审核通过理由字典（cache-and-network），结构与驳回字典一致 */
export const useReviewApproveReasons = () => {
    const {data, loading} = useQuery<GetReviewApproveReasonListResponse>(GET_REVIEW_APPROVE_REASON_LIST, {
        fetchPolicy: 'cache-and-network',
    });
    return {
        options: data?.getReviewApproveReasonList ?? [],
        loading,
    };
};

/** 按当前 locale 从字典项 texts 中选展示文案 */
export const pickRejectReasonText = (
    option: ReviewRejectReasonOption | undefined,
    locale: string,
): string => {
    if (!option) return '';
    return pickLocalizedText(option.texts, locale);
};
